import dynamic from "next/dynamic";
import React from "react";
import { useSpatialViewer } from "lib/contexts/SpatialContexts/SpatialViewerContext";
import Loading from "../Loading/Loading";

const CesiumViewer = dynamic(() => import("./CesiumViewer"), {
  ssr: false,
  loading: () => (
    <div className="absolute inset-0 flex flex-col items-center">
      <Loading />
    </div>
  ),
});

const CesiumViewHost = () => {
  const viewer = useSpatialViewer();
  const { x, y, w, h } = viewer?.position ?? { x: 0, y: 0, w: 0, h: 0 };
  const isVisible = w > 0 && h > 0 && !viewer?.isHidden;

  return (
    <div
      className="absolute overflow-hidden rounded-xl shadow-1"
      style={{
        visibility: isVisible ? "visible" : "hidden",
        left: x,
        top: y,
        width: w,
        height: h,
      }}
    >
      <CesiumViewer />
    </div>
  );
};

export default CesiumViewHost;
